<template>
  <div class="container">
    <h1>Edytuj profil</h1>
    <h4>Twoje dane:</h4>
    <div class="row mb-2">
      <p>
        Nazwa użytkownika: <span class="bold">{{ user.username }}</span>
      </p>
      <p>
        Email: <span class="bold">{{ user.email }}</span>
      </p>
    </div>
    <h4>Powiązane konta</h4>
    <div class="row mb-2">
      <div v-if="user.isConnectedWithFacebook">
        Jesteś połączony z kontem Facebook
      </div>
      <div v-else>
        <form method="post" action="/accounts/facebook/login/?process=connect">
          <input type="hidden" name="csrfmiddlewaretoken" :value="csrf" />
          Nie jesteś połączony z kontem Facebook.
          <button class="btn btn-sm">Połącz</button>
        </form>
      </div>
    </div>
    <div class="row mb-2">
      <div v-if="user.isConnectedWithGoogle">Jesteś połączony z Google</div>
      <div v-else>
        <form method="post" action="/accounts/google/login/?process=connect">
          <input type="hidden" name="csrfmiddlewaretoken" :value="csrf" />
          Nie jesteś połączony z kontem Google.
          <button class="btn btn-sm">Połącz</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("accounts", ["user", "csrf"]),
  },
};
</script>
<style scoped>
.bold {
  font-weight: bold;
}
</style>
